import { MapPolygonPoint } from './map.polygonPoint';
import { MapLatLng } from './map.latlng';

export abstract class MapPolygon {
    public id: number;       // Identificador secuencial
    public map: any;         // Mapa nativo
    public polygon: any;     // Poligono ativo
    public strokeColor: string;
    public strokeOpacity: number;
    public weight: number;
    public fillColor: string;
    public fillOpacity: number;
    public points: MapPolygonPoint[] = [];
    public editable: boolean;
    public hole: boolean;
    public content: string;

    constructor(id: number, map: any, strokeColor: string, strokeOpacity: number, weight: number,
        fillColor: string, fillOpacity: number, editable: boolean, hole: boolean, content: string) {
        this.id = id;
        this.map = map;
        this.strokeColor = strokeColor;
        this.strokeOpacity = strokeOpacity;
        this.weight = weight;
        this.fillColor = fillColor;
        this.fillOpacity = fillOpacity;
        this.editable = editable;
        this.hole = hole;
        this.content = content;
    }

    abstract remove(): any;
    abstract addPoint(id: number, content: string, position: MapLatLng, dataModel: any): MapPolygonPoint;
    abstract getNearbyPoint(position: any): MapPolygonPoint;
    abstract setContent(content: string): any;
}
